export default __webpack_public_path__ + "static/media/goodwipes-2.10ed98e6.webp";